import { Component } from 'react';
import {connect} from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import { translate } from '../withLocalize';

class Translate extends Component {

	static propTypes = {
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
		data: PropTypes.object,
		html: PropTypes.bool,
	};

	render() {
		const { lang, translations, id, data, html } = this.props;

		return translate(translations, lang, id, data, html);
	}
}

export default compose(
	connect((state) => ({
		translations: state.app.translations,
		lang: state.app.lang,
	}))
)(Translate);



// WEBPACK FOOTER //
// ./src/components/Translate.jsx